import {Component, OnInit} from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SelfSchedulingCommonService } from 'src/app-main/self.scheduling/services/self.scheduling.common.service';
import { LogCat } from 'src/common/log/log.categories';
import { LogManager } from 'src/common/log/log.manager';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(private router: Router, private commonService: SelfSchedulingCommonService) {

    }

    ngOnInit() {
        this.router.events.pipe(filter(event => event instanceof NavigationError)).subscribe((event: NavigationError) => {
            switch (event.error?.name) {
                case "ChunkLoadError":
                    LogManager.debug(LogCat.SelfScheduling.General, "Error loading application", event.error);
                    this.commonService.showErrorNotification("ConnectionError");
                    break;

                default:
                    LogManager.debug(LogCat.SelfScheduling.General, "Unknown error", event.error);
                    // this.commonService.showErrorNotification("UnknownError");
                    break;
            }
        });
    }
}
